import { axiosGetPaginatedRequest, getSearchRoute } from '../api';
import { Room } from '../community/rooms/models/Room';
import { MemberSearchType } from '../profile';
import { MemberInfo } from '../profile/model/MemberInfo';
import { CommunitySearchResult, PollSearchResult } from './model';
import { StorySearchResult } from './model/StorySearchResult';

const search = 'search/{numrecs}/{searchterm}';
const search_members = `members/${search}`;
const search_posts = `posts/${search}`;
const search_replies = `replies/${search}`;
const search_stories = `stories/${search}`;
const search_stories_comments = `comments/${search}`;
const search_rooms = `rooms/${search}`;
const search_polls = `surveys/${search}`;
const PAGE_SIZE = 2;

export const searchMembersCall = (
  searchString: string,
  numrecs?: number,
  xMsContinuationToken?: string,
  roomId?: string,
  searchThrough?: number
) => {
  return axiosGetPaginatedRequest<MemberInfo[]>(
    `${getSearchRoute()}/${search_members
      .replace('{numrecs}', (numrecs || PAGE_SIZE).toString())
      .replace('{searchterm}', searchString)}?roomId=${
      roomId || ''
    }&searchThrough=${searchThrough || MemberSearchType.all_members}`,
    xMsContinuationToken
  );
};
export const searchRoomsCall = (
  searchString: string,
  numrecs?: number,
  xMsContinuationToken?: string
) => {
  return axiosGetPaginatedRequest<Room[]>(
    `${getSearchRoute()}/${search_rooms
      .replace('{numrecs}', (numrecs || PAGE_SIZE).toString())
      .replace('{searchterm}', searchString)}`,
    xMsContinuationToken
  );
};

export const searchPostsCall = (
  searchString: string,
  numrecs?: number,
  xMsContinuationToken?: string
) => {
  return axiosGetPaginatedRequest<CommunitySearchResult[]>(
    `${getSearchRoute()}/${search_posts
      .replace('{numrecs}', (numrecs || PAGE_SIZE).toString())
      .replace('{searchterm}', searchString)}`,
    xMsContinuationToken
  );
};

export const searchRepliesCall = (
  searchString: string,
  numrecs?: number,
  xMsContinuationToken?: string
) => {
  return axiosGetPaginatedRequest<CommunitySearchResult[]>(
    `${getSearchRoute()}/${search_replies
      .replace('{numrecs}', (numrecs || PAGE_SIZE).toString())
      .replace('{searchterm}', searchString)}`,
    xMsContinuationToken
  );
};

export const searchPollsCall = (
  searchString: string,
  numrecs?: number,
  xMsContinuationToken?: string
) => {
  return axiosGetPaginatedRequest<PollSearchResult[]>(
    `${getSearchRoute()}/${search_polls
      .replace('{numrecs}', (numrecs || PAGE_SIZE).toString())
      .replace('{searchterm}', searchString)}`,
    xMsContinuationToken
  );
};

export const searchStoriesCall = (
  searchString: string,
  numrecs?: number,
  xMsContinuationToken?: string
) => {
  return axiosGetPaginatedRequest<StorySearchResult[]>(
    `${getSearchRoute()}/${search_stories
      .replace('{numrecs}', (numrecs || PAGE_SIZE).toString())
      .replace('{searchterm}', searchString)}`,
    xMsContinuationToken
  );
};

export const searchStoriesCommentsCall = async (
  searchString: string,
  numrecs?: number,
  xMsContinuationToken?: string
) => {
  const resp = await axiosGetPaginatedRequest<StorySearchResult[]>(
    `${getSearchRoute()}/${search_stories_comments
      .replace('{numrecs}', (numrecs || PAGE_SIZE).toString())
      .replace('{searchterm}', searchString)}`,
    xMsContinuationToken
  );
  return resp;
};
